// Lightweight client-side session helper. Server-side enforcement MUST be
// added when a backend is wired up — do not rely on this alone.
export type Role = "admin" | "merchant" | "user";

export type Session = {
  userId: string;
  email: string;
  role: Role;
};

const KEY = "spayzo.session.v1";

export function getSession(): Session | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Session;
    if (!parsed?.userId || !parsed?.role) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setSession(session: Session) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(KEY, JSON.stringify(session));
}

export function clearSession() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(KEY);
}

export function hasRole(session: Session | null, roles: Role[]): boolean {
  return !!session && roles.includes(session.role);
}
